const { createSlice } = require('@reduxjs/toolkit');

const subCategorySlice = createSlice({
    name: "subCategory",
    initialState: {
        subCategoryName: "",
        
    },
    reducers: {
        setsubCategory(state, action) {
            const subCategoryName = action.payload;

            return state = {
                subCategoryName
            };
            
           
        }
    },
});

export const { setsubCategory } = subCategorySlice.actions;
export default subCategorySlice.reducer;
